export default __webpack_public_path__ + "static/musica-86ee9b8409a1d624e7eb2fed6065c349.png";